/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { EntitlementEnum } from '../models/EntitlementEnum';
import { SubscriptionTypeEnum } from '../models/SubscriptionTypeEnum';
import { URI } from '../models/URI';
import { HttpFile } from '../http/http';

export class Actor {
    'id': number;
    'name'?: string;
    'gender'?: string;
    'avatar'?: URI;
    'uid': string;
    'subscriptionType': SubscriptionTypeEnum;
    'entitlement': EntitlementEnum;
    'aThumbnail'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "gender",
            "baseName": "gender",
            "type": "string",
            "format": ""
        },
        {
            "name": "avatar",
            "baseName": "avatar",
            "type": "URI",
            "format": "uri"
        },
        {
            "name": "uid",
            "baseName": "uid",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "subscriptionType",
            "baseName": "subscriptionType",
            "type": "SubscriptionTypeEnum",
            "format": ""
        },
        {
            "name": "entitlement",
            "baseName": "entitlement",
            "type": "EntitlementEnum",
            "format": ""
        },
        {
            "name": "aThumbnail",
            "baseName": "aThumbnail",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Actor.attributeTypeMap;
    }

    public constructor() {
    }
}

